import React, { useState, useEffect, useRef, useMemo } from 'react'
import { UserAuth } from '../../../context/AuthContext'
import { BiUserVoice, BiUserPlus } from 'react-icons/bi';
import { AiOutlinePlus } from 'react-icons/ai';
import { RiVipCrown2Line } from 'react-icons/ri';
import { IoMdHelpBuoy } from 'react-icons/io';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { MdContentCopy } from 'react-icons/md';
import { BsBorderInner } from 'react-icons/bs';
import { HiOutlineCog, HiOutlineBell } from 'react-icons/hi';
import { BsChevronRight, BsChevronDown, BsCheck } from 'react-icons/bs';
import { GrCloudlinux } from 'react-icons/gr';
import { Oval } from 'react-loader-spinner'
import ReactPaginate from 'react-paginate';

const Main = () => {

    const { user, lihatPasukan, lihatAirdrop, detailPasukan, lihatWallet, lihatGarapan } = UserAuth();
    const uname = user.displayName;

    const [dataPasukan, setDataPasukan] = useState([]);
    const [dataAirdrop, setDataAirdrop] = useState([]);
    const [dataWallet, setDataWallet] = useState([]);
    const [loading, setLoading] = useState({});
    useEffect(() => {
        const fetchData = async () => {
            setLoading(prevLoading => ({ ...prevLoading, pasukanList: true }));
            try {
                const result = await lihatPasukan(uname);
                setDataPasukan(result);
            } catch (error) {
                alert(error);
            } finally {
                setLoading(prevLoading => ({ ...prevLoading, pasukanList: false }));
            }
        };

        fetchData();
    }, [lihatPasukan, uname]);


    const [activePasukan, setActivePasukan] = useState('');

    const selectPasukan = async (selectedPasukan) => {
        setActivePasukan(selectedPasukan);
    }


    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage] = useState(6);
    const [searchQuery, setSearchQuery] = useState("");

    const filteredData = useMemo(() => {
        return dataPasukan.filter((item) => {
            return (
                item.telegram.toLowerCase().includes(searchQuery.toLowerCase())
            );
        });
    }, [dataPasukan, searchQuery]);

    const startIndex = filteredData.length > 0 ? currentPage * itemsPerPage + 1 : 0;
    const endIndex = Math.min(startIndex + itemsPerPage - 1, filteredData.length);
    const itemsToShow = filteredData.slice(startIndex - 1, endIndex);


    const [currentPageAirdrop, setCurrentPageAirdrop] = useState(0);
    const [itemsPerPageAirdrop] = useState(6);
    const [searchQueryAirdrop, setSearchQueryAirdrop] = useState("");

    const filteredDataAirdrop = useMemo(() => {
        return dataAirdrop.filter((item) => {
            return (
                item.name.toLowerCase().includes(searchQueryAirdrop.toLowerCase())
            );
        });
    }, [dataAirdrop, searchQueryAirdrop]);

    const startIndexAirdrop = filteredDataAirdrop.length > 0 ? currentPageAirdrop * itemsPerPageAirdrop + 1 : 0;
    const endIndexAirdrop = Math.min(startIndexAirdrop + itemsPerPageAirdrop - 1, filteredDataAirdrop.length);
    const itemsToShowAirdrop = filteredDataAirdrop.slice(startIndexAirdrop - 1, endIndexAirdrop);


    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    };

    const handlePageChangeAirdrop = ({ selected }) => {
        setCurrentPageAirdrop(selected);
    };

    /* Render Form */
    const pasukanList = itemsToShow.map((hasil, i) => {
        const isActive = activePasukan === hasil.telegram;

        return (
            <div
                key={i}
                onClick={() => selectPasukan(hasil.telegram)}
                className={`border border-r-0 hover:cursor-pointer py-2 px-3  ${isActive ? 'bg-zinc-900 border-slate-600' : 'hover:bg-neutral-700/90 border-transparent'
                    }`}>
                <div className={`font-medium ${isActive ? 'text-blue-400/60' : 'text-gray-300'
                    }`}>
                    {hasil.telegram.length > 18 ? (
                        hasil.telegram.slice(0, 14) + '...' + hasil.telegram.slice(-4)
                    ) : (
                        hasil.telegram
                    )}
                </div>
            </div>
        )

    });


    useEffect(() => {
        const fetchData = async () => {
            setLoading(prevLoading => ({ ...prevLoading, airdropList: true }));
            try {
                const result = await lihatAirdrop(uname);
                setDataAirdrop(result);
            } catch (error) {
                alert(error);
            } finally {
                setLoading(prevLoading => ({ ...prevLoading, airdropList: false }));
            }
        };

        fetchData();
    }, [lihatAirdrop, uname]);

    const [activeAirdrop, setActiveAirdrop] = useState('');

    const selectAirdrop = async (selectedAirdrop) => {
        setActiveAirdrop(selectedAirdrop);
    }

    /* Render Form */
    const airdropList = itemsToShowAirdrop.map((hasil, i) => {
        const isActive = activeAirdrop === hasil.name;

        return (
            <div
                key={i}
                onClick={() => selectAirdrop(hasil.name)}
                className={`hover:cursor-pointer py-2 pl-5 pr-4 ${isActive ? 'bg-gray-700/30' : 'hover:bg-sky-900'}`}>
                <div className={`font-medium ${isActive ? 'text-gray-200' : 'text-gray-300/70'}`}>
                    {hasil.name.length > 27 ? (
                        hasil.name.slice(0, 20) + '...' + hasil.name.slice(-4)
                    ) : (
                        hasil.name
                    )}
                </div>
            </div>
        )

    });


    const [nohpTelegram, setNohpTelegram] = useState('');
    const [usernameTelegram, setUsernameTelegram] = useState('');
    const [twitter, setTwitter] = useState('');
    const [email, setEmail] = useState('');
    const [facebook, setFacebook] = useState('');
    const [youtube, setYoutube] = useState('');
    const [medium, setMedium] = useState('');
    const [reddit, setReddit] = useState('');
    const [discord, setDiscordd] = useState('');

    /* Pasukan */
    const DataPasukan = [
        { id: 1, name: 'nohpTelegram', title: 'No HP', value: nohpTelegram },
        { id: 2, name: 'usernameTelegram', title: 'Telegram', value: usernameTelegram },
        { id: 3, name: 'twitter', title: 'Twitter', value: twitter },
        { id: 4, name: 'email', title: 'Email', value: email },
        { id: 5, name: 'discord', title: 'Discord', value: discord },
        { id: 6, name: 'facebook', title: 'Facebook', value: facebook },
        { id: 7, name: 'youtube', title: 'Youtube', value: youtube },
        { id: 8, name: 'medium', title: 'Medium', value: medium },
        { id: 9, name: 'reddit', title: 'Reddit', value: reddit }
    ];

    const GarapPasukan = DataPasukan.map((hasil, i) =>
        <tr key={hasil.id} className=''>
            <td className='py-2 px-3 font-semibold w-1/12'>{hasil.title}</td>
            <td className="py-2 px-3 w-2/4">
                {hasil.value.length > 46 ?
                    hasil.value.slice(0, 40) + '...' + hasil.value.slice(-4) :
                    hasil.value}</td>
            <td className='py-2 px-3 w-3/12 font-sans'>
                <div className="flex justify-end items-center">
                    <div>
                        <CopyToClipboard text={hasil.value}>
                            <button className="py-2 px-2 text-zinc-200 bg-neutral-700/60 text-sm font-medium rounded-md flex items-center">
                                <MdContentCopy size='16px' className='text-neutral-50/70 mr-1' /> Copy
                            </button>
                        </CopyToClipboard>
                    </div>
                    <div className='text-xs pl-1'>Alt + {i + 1}</div>
                </div>
            </td>
        </tr>

    );

    useEffect(() => {
        const ajg = async () => {
            const result = await detailPasukan(uname, activePasukan);
            setNohpTelegram(result[0].nohpTelegram);
            setUsernameTelegram(result[0].usernameTelegram);
            setTwitter(result[0].twitter);
            setEmail(result[0].email);
            setFacebook(result[0].facebook);
            setYoutube(result[0].youtube);
            setMedium(result[0].medium);
            setReddit(result[0].reddit);
            setDiscordd(result[0].discord);
        }
        ajg();
    }, [uname, detailPasukan, activePasukan])


    const [showInput, setShowInput] = useState(false);


    // Update the showInput state whenever activePasukan or activeAirdrop changes
    useEffect(() => {
        if (activePasukan && activeAirdrop) {
            setShowInput(true);
        } else {
            setShowInput(false);
        }
    }, [activePasukan, activeAirdrop]);


    const [searchText, setSearchText] = useState('');

    const handleSearchTextChange = (event) => {
        setSearchText(event.target.value);
    };

    const listWallets = dataWallet.map((hasil, index) => {
        let infoAddress = '';
        if (hasil.label !== '') {
            infoAddress = `[${hasil.label}]`;
        } else {
            infoAddress = '';
        }
        return {
            address: hasil.address,
            infoAddress: infoAddress,
        };
    });

    const filteredOptions = listWallets.filter((option) =>
        option.address.toLowerCase().includes(searchText.toLowerCase())
    );


    const noOptionsFound = filteredOptions.length === 0;


    const searchInputRef = useRef(null); // create a ref to the search input element

    const handleDropdownButtonClick = () => {
        document.getElementById('walletList').classList.toggle('hidden');
        searchInputRef.current.focus(); // focus on the search input element
    };

    const handleOptionClick = (option) => {
        setSelectedWallet(option);
        document.getElementById('walletList').classList.add('hidden');
    };

    const [selectedWallet, setSelectedWallet] = useState('Pilih Wallet Address (Optional)')


    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await lihatWallet(uname);
                setDataWallet(result);
            } catch (error) {
                console.log(error)
            }
        };

        fetchData();
    }, [lihatWallet, uname]);


    const [nameGarapan, setNameGarapan] = useState('');
    const [chainGarapan, setChainGarapan] = useState('');
    const [linkGarapan, setLinkGarapan] = useState('');
    const [noteGarapan, setNoteGarapan] = useState('');
    const [jumlah, setJumlah] = useState('')

    useEffect(() => {
        if (activeAirdrop) {
            const fetchData = async () => {
                const result = await lihatGarapan(uname, activeAirdrop);
                setNameGarapan(result[0].name);
                setChainGarapan(result[0].chain);
                setLinkGarapan(result[0].link);
                setNoteGarapan(result[0].note);
                setJumlah(result[0].totalPenggarap)
            };

            fetchData();
        }
    }, [uname, activeAirdrop, lihatGarapan]);
    return (
        <div className='max-h-screen min-h-screen bg-zinc-900 flex flex-col'>
            <div className='px-4 py-2 flex justify-between items-center z-10'>
                <div>
                    <h1 className='text-3xl text-gray-400 font-semibold'>Garap Airdrop by IziUSE v1.0</h1>
                </div>
                <div className='pr-2 flex items-center'>

                    <div>
                        <button className="py-2 px-3 text-zinc-200 bg-neutral-700/60 text-sm font-medium rounded-md flex items-center">
                            <BiUserPlus size='20px' className='text-neutral-50/70 mr-2' /> Invite
                        </button>
                    </div>
                    <div className='ml-4 flex items-center justify-center font-medium text-lg rounded-full bg-rose-600 text-white w-[36px] h-[36px]'>Z</div>
                </div>
            </div>
            <div className='h-[1px] w-full bg-gray-700 z-10'></div>
            <div className='flex flex-row flex-grow max-h-screen min-h-0'>
                <div className='basis-1/5 flex flex-col flex-shrink-0 min-h-max'>
                    <div className="border-r border-r-gray-700/80 relative flex-shrink-0 flex flex-col flex-grow">
                        <div className='flex flex-col py-2 relative h-full'>
                            <div className='mb-2'>
                                <div
                                    className='border border-r-0 hover:cursor-pointer border-transparent'>
                                    <input
                                        type='text'
                                        placeholder='Search...'
                                        className='w-full text-sm bg-black text-white border-r-0 border-l-0 border border-gray-800 focus:ring-0 focus:border-primary'
                                        value={searchQueryAirdrop}
                                        onChange={(event) => {
                                            setSearchQueryAirdrop(event.target.value);
                                            setCurrentPageAirdrop(0);
                                        }} />
                                </div>
                            </div>
                            {loading.airdropList && (
                                <div className="absolute inset-0 flex items-center justify-center bg-zinc-900">
                                    <h1 className='text-white'>
                                        <Oval
                                            height={20}
                                            width={20}
                                            color="#007bff"
                                            wrapperStyle={{}}
                                            wrapperClass=""
                                            visible={true}
                                            ariaLabel='oval-loading'
                                            secondaryColor="#60a5fa"
                                            strokeWidth={6}
                                            strokeWidthSecondary={6}

                                        />
                                    </h1>
                                </div>
                            )}
                            {airdropList}
                            <div className='text-sm text-gray-500 mt-4 pl-5'>
                                Showing {startIndexAirdrop > 0 ? startIndexAirdrop : 0} to {endIndexAirdrop} of {filteredDataAirdrop.length} entries
                            </div>
                            <ReactPaginate
                                previousLabel={
                                    <span className="px-2 py-2">
                                        &lt;
                                    </span>
                                }
                                nextLabel={
                                    <span className="px-2 py-2">
                                        &gt;
                                    </span>
                                }
                                breakLabel='...'
                                pageCount={Math.ceil(dataAirdrop.length / itemsPerPageAirdrop)}
                                marginPagesDisplayed={0}
                                pageRangeDisplayed={0}
                                onPageChange={handlePageChangeAirdrop}
                                containerClassName={'flex justify-center mt-4 text-xs text-white'}
                                activeClassName={'bg-neutral-600/50 text-white px-4 py-2 !important'}
                                pageClassName={'border border-gray-700 px-4 py-2'}
                                breakClassName={'border border-gray-700 px-4 py-2'}
                                previousClassName={'border border-gray-700 px-2 py-2'}
                                nextClassName={'border border-gray-700 px-2 py-2'}
                            />
                        </div>
                        <div id="footer" className='border-t border-t-gray-700 mt-auto'>
                            <div
                                className='hover:cursor-pointer py-2 pl-5 pr-4 hover:bg-sky-900 mt-2'>
                                <div className='font-medium text-zinc-400 flex items-center'>
                                    <span className='mr-2'>
                                        <RiVipCrown2Line size='18px' />
                                    </span>
                                    Upgrade Akun
                                </div>
                            </div>
                            <div
                                className='hover:cursor-pointer py-2 pl-5 pr-4 hover:bg-sky-900'>
                                <div className='font-medium text-zinc-400 flex items-center'>
                                    <span className='mr-2'>
                                        <IoMdHelpBuoy size='20px' />
                                    </span>
                                    FAQ dan Bantuan
                                </div>
                            </div>
                            <div className='flex justify-between items-center py-4 px-6'>
                                <div>
                                    <div className='w-[38px] flex flex-col items-center'>
                                        <div className='h-[38px] w-[38px] rounded-full hover:cursor-pointer hover:bg-zinc-800/80'>
                                            <span className='w-full h-full flex items-center justify-center text-gray-300'>
                                                <BsBorderInner size='16' />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='w-[40px] flex flex-col items-center'>
                                    <div className='h-[40px] w-[40px] rounded-full bg-blue-400'>
                                        <span className='w-full h-full flex items-center justify-center'>
                                            <AiOutlinePlus size='20px' className='text-white' />
                                        </span>
                                    </div>
                                </div>
                                <div>
                                    <div className='w-[38px] flex flex-col items-center'>
                                        <div className='h-[38px] w-[38px] rounded-full hover:cursor-pointer hover:bg-zinc-800/80'>
                                            <span className='w-full h-full flex items-center justify-center text-gray-300'>
                                                <HiOutlineCog size='20' />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className='basis-1/5 flex flex-col flex-shrink-0 min-h-max'>
                    <div className="bg-neutral-900 border-r border-r-gray-700/80 relative flex-shrink-0 flex flex-col flex-grow">
                        <div className='flex flex-col py-2 pl-6 relative h-full'>
                            <div className='mb-2'>
                                <div
                                    className='border border-r-0 hover:cursor-pointer border-transparent'>
                                    <input
                                        type='text'
                                        placeholder='Search...'
                                        className='w-full text-sm bg-black text-white border-r-0 border border-gray-800 focus:ring-0 focus:border-primary'
                                        value={searchQuery}
                                        onChange={(event) => {
                                            setSearchQuery(event.target.value);
                                            setCurrentPage(0);
                                        }} />
                                </div>
                            </div>
                            {loading.pasukanList && (
                                <div className="absolute inset-0 flex items-center justify-center bg-neutral-900">
                                    <h1 className='text-white'>
                                        <Oval
                                            height={20}
                                            width={20}
                                            color="#007bff"
                                            wrapperStyle={{}}
                                            wrapperClass=""
                                            visible={true}
                                            ariaLabel='oval-loading'
                                            secondaryColor="#60a5fa"
                                            strokeWidth={6}
                                            strokeWidthSecondary={6}

                                        />
                                    </h1>
                                </div>
                            )}
                            {pasukanList}
                            <div className='text-sm text-gray-500 mt-4 px-3'>
                                Showing {startIndex > 0 ? startIndex : 0} to {endIndex} of {filteredData.length} entries
                            </div>
                            <ReactPaginate
                                previousLabel={
                                    <span className="px-2 py-2">
                                        &lt;
                                    </span>
                                }
                                nextLabel={
                                    <span className="px-2 py-2">
                                        &gt;
                                    </span>
                                }
                                breakLabel='...'
                                pageCount={Math.ceil(dataPasukan.length / itemsPerPage)}
                                marginPagesDisplayed={0}
                                pageRangeDisplayed={0}
                                onPageChange={handlePageChange}
                                containerClassName={'flex justify-center mt-4 text-xs text-white'}
                                activeClassName={'bg-neutral-600/50 text-white px-4 py-2 !important'}
                                pageClassName={'border border-gray-700 px-4 py-2'}
                                breakClassName={'border border-gray-700 px-4 py-2'}
                                previousClassName={'border border-gray-700 px-2 py-2'}
                                nextClassName={'border border-gray-700 px-2 py-2'}
                            />
                            <div className='mt-4 py-2 px-3 hover:bg-gray-700/90 w-full border-t border-t-neutral-700/80'>
                                <div className='font-medium text-gray-300 flex items-center'>
                                    <span className='mr-2'>
                                        <BiUserVoice size='22px' />
                                    </span>
                                    Tambah Pasukan</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="basis-3/5 min-h-max overflow-y-auto overscroll-y-auto relative">
                    {chainGarapan && (
                        <div className='absolute -rotate-45 z-100 pt-6'>
                            <span className='text-sm box-decoration-slice bg-gradient-to-r from-cyan-500 to-primary text-white px-2 py-1'>

                                {chainGarapan.length > 8 ? (
                                    chainGarapan.slice(0, 4) + '...' + chainGarapan.slice(-2)
                                ) : (
                                    chainGarapan
                                )}
                            </span>

                        </div>
                    )}
                    <div className='py-6 px-9 z-0'>
                        <div className='flex items-center justify-between'>
                            <h1 className="text-4xl text-gray-100 font-bold px-3">
                                {activeAirdrop ?
                                    activeAirdrop.length > 20 ? (
                                        'Garap ' + activeAirdrop.slice(0, 13) + '...' + activeAirdrop.slice(-4)
                                    ) : (
                                        'Garap ' + activeAirdrop
                                    )
                                    : 'Selamat datang'}
                            </h1>
                            {activeAirdrop && (
                                <div className='flex flex-row'>
                                    {jumlah > 0 ? (
                                        <div className='text-sm border border-indigo-500 bg-violet-400 px-3 py-1 text-white font-semibold rounded-md'>Digarap {jumlah}x</div>
                                    ) : (
                                        <div className='text-sm border border-amber-500 bg-orange-600 px-3 py-1 text-gray-200 font-semibold rounded-md'>Belum digarap</div>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className='py-4'>
                            <div className='flex flex-row'>
                                <div>
                                    <h2 className='text-xl text-gray-400 font-semibold pl-3'>
                                        {activePasukan
                                            ? 'Pasukan ' + (
                                                activePasukan.length > 46
                                                    ? activePasukan.slice(0, 39) + '...' + activePasukan.slice(-4)
                                                    : activePasukan
                                            )
                                            : 'Pilih airdrop dan pasukan yang akan dikerjakan'
                                        }
                                    </h2>

                                    {activePasukan && activeAirdrop && (
                                        <p className='text-gray-400 text-xs pl-3 mt-1'>Setelah selesai garap airdrop dengan data di bawah, kamu bisa menekan tombol centang</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className='pl-3'>
                            <div className={`overflow-x-auto border font-mono border-stone-600/50 rounded-md ${showInput && ('ring-2 ring-black/50')}`}>
                                <div className='p-4 flex flex-row items-center'>
                                    <div className=''>
                                        {showInput ? (
                                            <BsChevronDown className='ml-1 fill-current text-gray-400 hover:cursor-pointer' size='14' onClick={() => setShowInput(!showInput)} />
                                        ) : (
                                            <BsChevronRight className='ml-1 fill-current text-gray-400 hover:cursor-pointer' size='14' onClick={() => setShowInput(!showInput)} />
                                        )}
                                    </div>
                                    <div className='pl-4 flex flex-row items-center justify-start'>
                                        <div className='flex items-center'>
                                            {activePasukan && activeAirdrop && (
                                                <button className='bg-primary rounded-full flex flex-row justify-center items-center w-[24px] h-[24px]'>
                                                    <BsCheck size='24px' className='text-blue-100/70' />
                                                </button>
                                            )}
                                            <button className='ml-2 bg-green-600 text-white text-xs font-extrabold py-1 px-2 rounded-full tracking-widest'>WALLET</button>
                                        </div>
                                        {showInput && activePasukan && activeAirdrop && (
                                            <div className='pl-2'>
                                                <div className='rounded-md px-3 py-1 text-white text-sm bg-black flex items-start'>
                                                    Selected:
                                                    <div className='px-1 flex flex-col items-start ml-2 relative flex-grow'>
                                                        <div
                                                            className='flex items-center justify-between bg-neutral-600/70 px-1 cursor-pointer'
                                                            onClick={handleDropdownButtonClick} >
                                                            {selectedWallet}
                                                            <span className='ml-1'>
                                                                <BsChevronDown size='12px' />
                                                            </span>
                                                        </div>
                                                        <div id="walletList" className='bg-neutral-600/70 absolute z-10 top-full flex-shrink-0 hidden flex-grow'>
                                                            <div className='px-1 py-1 flex-shrink-0'>
                                                                <div className="">
                                                                    <input
                                                                        type='text'
                                                                        placeholder='Search...'
                                                                        className='w-full text-sm py-0 px-1 bg-black text-white border border-white focus:ring-0 focus:border-white'
                                                                        value={searchText}
                                                                        onChange={handleSearchTextChange}
                                                                        ref={searchInputRef} />
                                                                </div>
                                                            </div>
                                                            <div className=''>
                                                                {noOptionsFound ? (
                                                                    <div className='bg-red-500 whitespace-nowrap px-1'>
                                                                        No options.
                                                                    </div>
                                                                ) : (
                                                                    filteredOptions.map((option) => (
                                                                        <div
                                                                            key={option.address}
                                                                            className='px-1 text-sm hover:cursor-pointer hover:bg-neutral-400/60 whitespace-nowrap'
                                                                            onClick={() => handleOptionClick(option.address)}
                                                                        >
                                                                            {option.address} {option.infoAddress}
                                                                        </div>
                                                                    ))
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <CopyToClipboard text={selectedWallet}>
                                                        <div className='ml-2 px-1 bg-neutral-500 cursor-pointer'>
                                                            Copy
                                                        </div>
                                                    </CopyToClipboard>
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                </div>
                                {showInput && activePasukan && activeAirdrop && (
                                    <div className='pl-10'>
                                        <table className='w-full items-center text-left table-auto'>
                                            <tbody className='font-normal text-sm text-gray-300'>
                                                {GarapPasukan}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='bg-gray-700 h-[1px] mt-8 ml-3'></div>
                        <div className='py-8 pl-3'>
                            <div className='flex flex-row justify-between'>
                                <div>
                                    <h2 className='text-xl text-gray-200 font-semibold'>
                                        Beranda Profesional
                                    </h2>
                                    <p className='pt-1 text-gray-400 text-sm'>Lihat kabar terbaru dari kami</p>
                                </div>
                                <div>
                                    <button className='rounded-md border border-neutral-700/60  text-neutral-50/70 px-2 py-1 text-sm font-medium'>Lihat Semua</button>
                                </div>
                            </div>
                            <div className="grid grid-rows-2 gap-4 px-4 pb-2 pt-4">
                                <div className='flex flex-row items-start'>
                                    <GrCloudlinux className='mr-2 text-gray-400' size='24px' />
                                    <div className=''>
                                        <p className='font-medium md:text-sm text-xs text-gray-100'>Pemberitahuan Sistem  </p>
                                        <p className='font-normal md:text-sm text-xs text-gray-400'> Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
                                    </div>
                                </div>
                                <div className='flex flex-row items-start'>
                                    <HiOutlineBell className='mr-2 text-gray-400' size='24px' />
                                    <div className=''>
                                        <p className='font-medium md:text-sm text-xs text-gray-100'>Notifikasi Pesan  </p>
                                        <p className='font-normal md:text-sm text-xs text-gray-400'> Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Main
